import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';

import { jsPDF } from "jspdf";

import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType, clearSignatureDifferenceType,
		setShowUpgradeCard } from '../../actions/localStates'
import { fromBytes } from '../../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';

import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import QRPopup from './QRPopup'
import PrivateSignPopup from './PrivateSignPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();


class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null,
	    	showPrivateSignPopup: false
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);

	    this.handleShowPrivateSign = this.handleShowPrivateSign.bind(this);
	}

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    handleShowPrivateSign (base64Image) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				privateSignImage: base64Image
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPrivateSignPopup: !this.state.showPrivateSignPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	downloadSignedData() {
		function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

        // var dataFileName = removeExtraExtensions(name)
        var dataFileName = removeTrailingP7sExtensions(this.props.defaultState.fileWithDSName)

    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid;

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value.length > 0) {
					var isElectronicStampTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:isElectronicStampTitle") + isElectronicStampTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType)
					str += i18next.t("ds:signatureType") + signatureType + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat)
					str += i18next.t("ds:" + signatureFormat) + "\n"
				}

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());

	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), cleaned = "", verticalOffset = 65, needSort = true, archTimestampCounter = 0, dataFileName = "", maxWidth = 120, tempOffset = 0, tempOffsetSecond = 0, wrappedText, failureCauseSplited;
		var img = 'data:image/png;base64,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'

		this.props.defaultState.verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				return;
			}
		})

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		if (needSort) {
			this.props.defaultState.verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

		doc.setFont('Roboto-Regular', 'normal');

		function footer(){ 
			doc.setFont("Roboto-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString()); //print number bottom right
		    doc.page += 1;
		};

		doc.page = 1;

		footer()

		// var str = this.generateTextResult();
		
		doc.addImage(img, 'PNG', 10, 5, 50, 24)

		doc.setFontSize(8);
   		doc.text(i18next.t("titlePdf"), 200, 9, {align:'right'});
   		doc.text(i18next.t("streetAdddresPdf"), 200, 12, {align:'right'});
   		doc.text(i18next.t("phonePdf"), 200, 23, {align:'right'});
   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
   		doc.textWithLink("E-mail: contact-centre@oschadbank.ua", 200, 26, {align:'right'});
   		doc.textWithLink("Web: www.oschadbank.ua", 200, 29, {url: 'www.oschadbank.ua', align:'right'});
   		doc.line(10, 30, 200, 30);

   		doc.setFont('Roboto-Regular', 'bold');
   		doc.setFontSize(18);
   		doc.text(i18next.t("clientTitlePdf"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolTitlePdf"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Roboto-Regular', 'normal');
   		doc.text(i18next.t("verifyTitlePdf"), 105, 53, {align:'center'});

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimePdf"), 10, 60);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), this.props.localesReducer.language === "en" ? 33 : 32, 60);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 66);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);

   		maxWidth = 120;

		wrappedText = doc.splitTextToSize(this.props.defaultState.fileWithDS.name, maxWidth);
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 40 : 55, 66);

		if (wrappedText.length > 1) {
			tempOffset = 5;
		}

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 70 + tempOffset);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 36 : 56, 70 + tempOffset);

   		var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);

   		doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);

   		function hasSingleExtension(filename) {
		    const parts = filename.split(".");

		    return parts.length === 2;
		}

		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$0');
        }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

		function hasAsicExtension(filename) {
		  const ext = filename.split('.').pop().toLowerCase();
		  return ext === 'asics' || ext === 'asice';
		}

  		if (this.props.defaultOptionState.signatureType === "detached") {
			dataFileName = this.props.defaultState.fileInput.name
		} else {
			cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
			dataFileName = cleaned
		}

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			dataFileName = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			dataFileName = "-"
		}

		maxWidth = 140;

		wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

		if (wrappedText.length > 1) {
			tempOffsetSecond = 5;
		}
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 43 : 56, 74 + tempOffset);

		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78 + tempOffset + tempOffsetSecond);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			str = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			str = "-"
		}

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 40 : 58, 78 + tempOffset + tempOffsetSecond);

   		verticalOffset = verticalOffset + 10
   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
   			if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
   				archTimestampCounter += 1;
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
   			} else {
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
   			}
			// isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (verticalOffset + 90 > 290) {
				verticalOffset = 10;
				doc.addPage();
				footer()
				doc.setFont('Roboto-Regular', 'normal');

		   		doc.setFontSize(10);
			}

			verticalOffset = verticalOffset + 10

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("red");

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
					
				} else {
					doc.setFont("Roboto-Bold", 'normal');

					if (this.props.defaultState.verifyResults[i].isValid) {
						doc.setTextColor("green");
					} else {
						doc.setTextColor("red");
					}

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
						
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
				}

				verticalOffset = verticalOffset + 5;
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("black");

				var isQualified
				if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:unqualifiedTitleShe")
				} else {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				}
				// var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				// doc.text(i18next.t("dsType") + isQualified, 10, verticalOffset);
				doc.text(isQualified, 10, verticalOffset);

				// verticalOffset = verticalOffset + 5;

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, this.props.localesReducer.language === "en" ? 24 : 33, verticalOffset);
				}
				// doc.setFont("Roboto-Bold", 'normal');
				// doc.setTextColor("black");
				// doc.text(i18next.t("ds:signer"), 10, verticalOffset);
				// doc.setFont("Roboto-Regular", 'normal');
				// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, 32, verticalOffset);

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 33 : 33, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 26 : 27, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
			
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }

		        if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, this.props.localesReducer.language === "en" ? 20 : 38, verticalOffset);
		       	}
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitleForPdf"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), this.props.localesReducer.language === "en" ? 68 : 88, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 32 : 34, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Roboto-Regular", 'normal');
							doc.text("Відсутня", 70, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 36 : 34, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), this.props.localesReducer.language === "en" ? 34 : 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), this.props.localesReducer.language === "en" ? 55 : 80, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumberForPdf"), 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 76 : 96, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), this.props.localesReducer.language === "en" ? 76 : 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), this.props.localesReducer.language === "en" ? 63 : 83, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Roboto-Bold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDSForPdf"), 10, verticalOffset);
					            	doc.setFont("Roboto-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, 90, verticalOffset);
				            	}
				            }
				        }

					}
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 39 : 46, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 45 : 58, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 22 : 29, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, this.props.localesReducer.language === "en" ? 31 : 38, verticalOffset);
				}

            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), this.props.localesReducer.language === "en" ? 38 : 39, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), 39, verticalOffset);
            	}

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("red");
				doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				doc.text(i18next.t("ds:notDefined"), 28, verticalOffset);

				var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
				doc.setFont("Roboto-Regular", 'normal');
				doc.setTextColor("black");

				verticalOffset = verticalOffset + 5;

				for (var c = 0; c < splitText.length; c += 1){
			        doc.text(10, verticalOffset, splitText[c]);
			        verticalOffset = verticalOffset + 5;
			    }
			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Roboto-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyAddressPdf"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("caas.oschadbank.ua", 10, verticalOffset + 5, {url: 'caas.oschadbank.ua'});

   		// doc.output("dataurlnewwindow");
   		if (this.props.defaultState.fileInputName.length > 0) {
			doc.save(this.props.defaultState.fileInputName + ".pdf")
		} else {
			doc.save(this.props.defaultState.fileWithDSName + ".pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div><span className="font-weight-bold">{tsTypeString()}</span>{i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this, needSort = true, isNested = false, archTimestampCounter = 0, failureCauseSplited;
		var generateVerifyResultsViewSimple = generateVerifyResultsViewSimple.bind(this);

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];


		verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				isNested = true;
				return;
			}
		})

		if (needSort) {
			verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

        if (this.props.defaultOptionState.showUpgradeCard) {
        	verifyResults.forEach(function (element) {
	        	_this.props.defaultState.differenceSignatureType.forEach(function (secondElement) {
	        		if (element.signerInfo.certificateSerialNumber !== undefined) {
	        			if (element.signerInfo.certificateSerialNumber.value === secondElement.signerInfo.certificateSerialNumber.value) {
		        			diffType.push(secondElement)
		        		}
	        		}
	        	})
	        })
        }

        function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].isUntrustedValid) {
					failureCauseSplited = verifyResults[i].failureCause.split('\n')
				}

				if (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					archTimestampCounter += 1;
				}

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].contentTimestamp).length === 0) && (verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        	{	
		        		verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
		    			: i18next.t("ds:signature") + ((i + 1) - archTimestampCounter)
		        	}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				{
		    					verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP"
		    					? <div><span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span></div>
		    					: null
		    				}
		    			</div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {

								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        

					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}

			        		{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
					        		</div> : null
					        }
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{(verifyResults[i].signatureImageData !== null && verifyResults[i].signatureImageData !== undefined && verifyResults[i].signatureImageData.length > 0) ? <div style={{paddingRight: "15px"}}><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>{i18next.t("hwsImageLabel")}</label><img style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}} src={"data:image/png;base64," + verifyResults[i].signatureImageData} onClick={this.handleShowPrivateSign.bind(this, verifyResults[i].signatureImageData)} alt="" /></div> : null}{this.props.defaultOptionState.generateQR ? <div><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px", paddingTop: "10px"}}>{i18next.t("QRSignLabel")}</label><img src={this.props.defaultState.verifyResultsForQR[i]} onClick={this.handleShowQR.bind(this, i)} style={{width: "100px", height: "100px", cursor: "pointer"}} alt="" /></div> : null}</div><div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{failureCauseSplited[0]}</b></p>
						            		}
						            		
						            		{/*{
						            			this.props.defaultOptionState.signatureTsVerifyOption !== 'ignore'
						            			? <p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>
						            			: null
						            		}*/}
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{/*{
							            verifyResults[i].isUntrustedValid && this.props.defaultOptionState.signatureTsVerifyOption !== 'ignore'
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }*/}
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }

		function buildTree(items) {
		  const tree = [];
		  const lastAtLevel = {};

		  items.forEach(item => {
		    const level = item.degreeOfNesting !== undefined
		      ? Number(item.degreeOfNesting)
		      : 0;

		    const node = { ...item, children: [] };

		    if (level === 0) {
		      tree.push(node);
		      lastAtLevel[0] = node;
		    } else {
		      const parent = lastAtLevel[level - 1];
		      if (parent) {
		        parent.children.push(node);
		      } else {
		        console.warn("No parent found for node:", node);
		        tree.push(node); // fallback
		      }
		      lastAtLevel[level] = node;
		    }

		    Object.keys(lastAtLevel).forEach(k => {
		      if (Number(k) > level) delete lastAtLevel[k];
		    });
		  });

		  return tree;
		}

		function addIds(items) {
		  return items.map((item, index) => ({
		    ...item,
		    id: index + 1
		  }));
		}

		const updatedData = addIds(verifyResults);

		const tree = buildTree(updatedData);

		const TreeNode = ({ node }) => {
		  return (
		    <div style={styles.parent}>
		      <div>
		          	{
		          		node.status === "SUCCESS"
		        		? <div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>

		        			<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>
				        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						    			{i18next.t("ds:signature") + node.id}
						        	</div>
			        				
			        				{
				        				resultType === "verifyResults"
				        				? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        				:   <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
							        			{
							        				node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        			}

			        				{this.props.defaultOptionState.generateQR
				        				? <img src={this.props.defaultState.verifyResultsForQR[node.id - 1]} onClick={this.handleShowQR.bind(this, node.id - 1)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" />
				        				: null} 
			        			</div> 
				        			<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
					    			</div>
					    				{
											node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
								        		</div> : null
								        } {
											node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
									        	<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
								        		</div> : null
								        } {
								        	node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
								        		<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
								        		</div> : null
								        }
					    			<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{node.signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
					        		</div>
					        		 	{
								        	node.signerInfo.certificateSerialNumber.value ? 
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{node.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
								        		</div> : null
					                    }
					    			<div>
					    				{
					    					node.signingDateTime !== undefined && node.signingDateTime.length > 0
					    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(node.signingDateTime)}</span></span>
					    					: null
					    				}
					    			</div>
					    			<div>
					    				{
					    					this.constructTimestampDetails(node.contentTimestamp, "content")
					    				}
					    			</div>
					    			<div>
					    				{
					    					node.signatureTimestamps.map((element) => (
					    						this.constructTimestampDetails(element, "signature")
					    					))
					    				}
					    				
					    			</div>
					    			<div>
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
					    				{
											node.signerInfo.extensionsCertificateInfo.value.isQualified ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
								        		</div> : null
								        }
								        {
											node.signatureType ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{node.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureType)}</span>
								        		</div> : null
								        }
								        {
											node.signatureFormat ?
						                        <div>
						                        	{
						                        		node.signatureFormat !== null && node.signatureFormat === "CADES_T" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
						                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
						                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{node.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureFormat)}</span></div>
						                        	}
								    				
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
								        		</div> : null
								        }
					    			</div>
					    		</div>
			        			</div>
			        		</div>        			
		        			
		        				
		        		  </div>
		        		: <div>
		        			<div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
							    			{i18next.t("ds:signature") + node.id}
							        	</div>
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						        			{i18next.t("ds:notDefined")}
						        		</div>
				        			</div>
				        			<div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
							    			<div>
							    				{ node.failureCause }
							    				{/*{
										            node.isUntrustedValid
										            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
										            : null
										        }*/}
							    			</div>
						    			</div>
				        			</div>
				        		</div>
				        	</div>
		        		</div>
		          	}
		          
		        </div>
		      {node.children.length > 0 && (
		        <div style={styles.children}>
		          {node.children.map((child, index) => (
		          	node.children.length > 1 && ((index + 1) % 2 === 0)
		          	? <div style={{marginTop: "10px"}}><TreeNode key={child.id} node={child} /></div>
		          	: <TreeNode key={child.id} node={child} />
		          ))}
		        </div>
		      )}
		    </div>
		  );
		};

		const TreeView = ({ data }) => {
			console.log("tree", JSON.stringify(tree, null, 2));
		  return (
		    <div style={styles.tree}>
		      {data.map((node, index) => (
		        <TreeNode key={node.id} node={node} />
		      ))}
		    </div>
		  );
		};

		const styles = {
		  tree: {
		    display: "flex",
		    flexDirection: "column",
		    marginBottom: "10px"
		  },
		  parent: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  node: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  children: {
		    marginTop: "10px"
		  }
		};

		function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}


		if (!this.props.defaultOptionState.showUpgradeCard) {
			if (isNested) {
	        	rootDiv.push(<div id="divPtblg">{
	        		<TreeView data={tree} />
	        	}</div>)
	        } else {
	        	generateVerifyResultsViewSimple(verifyResults)
	        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
	        }
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}
          
        return rootDiv

    }

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileInputSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}

		                                  </div>
		                                  : <div>
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
		                                  		}
											</div>
		                                }
	                                </div>
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
	                                    {
											this.props.defaultState.fileWithDSSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultState.fileWithDSSelected
	                                    		? <div className="input-group mb-4">
													<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
												: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
	                                      </div>
	                                    
	                                }
                                </div>
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults !== null && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
		                            	{
		                            		this.props.base.pdfReportEnabled === "true"
		                            		? <span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("inspectionReport")}</span>
		                            		: null
		                            	}
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }

                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        {
		                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1 row no-left-no-right-padding" style={{"marginLeft": "0px", "marginRight": "0px"}}>
		                        		<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12"><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData")}</button></div>
		                        	</div>
		                        	: null
		                        }
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                    {
	                        this.state.showPrivateSignPopup
	                        ? <PrivateSignPopup closePrivateSignPopup={this.handleShowPrivateSign} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType,
    	fromBytes, setShowUpgradeCard
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);